import { useRef } from "react";
import { ref, onValue, off } from "firebase/database";
import { getEventStatusDocRef } from "../eventStatus.firebase";

const useEventStatus = () => {
  const docRef = useRef<ReturnType<typeof ref> | null>(null);

  const subscribe = (eventId: string, callback: (status: string) => void) => {
    docRef.current = getEventStatusDocRef(eventId);
    onValue(docRef.current, (snapshot) => {
      const eventStatus = snapshot.val();
      callback(eventStatus);
    });
  };

  const unsubscribe = () => {
    if (docRef.current) {
      off(docRef.current);
    }
  };

  return {
    subscribe,
    unsubscribe,
  };
};

export default useEventStatus;
